<!--
 * @name: 萝卜兄台
 * @Date: 2022-07-25 14:38:28
 * @LastEditors: DESKTOP-IQPBHI4\mi leili995997651@qq.com
 * @LastEditTime: 2022-07-26 16:12:29
 * @FilePath: \recognize_www\src\page\behind\account\components\changePw\index.vue
 * @Description: 这是描述
-->
<template>
  <div class="pw">
    <div class="pwTitle">{{ $t(`account.changePassword`) }}</div>
    <div class="pwConte">
      <div class="pwConteForm">
        <a-form :model="formState" name="basic" ref="formRef" :label-col="labelCol" @finish="onFinish">
          <a-form-item :label="$t(`account.rawPassword`)" name="oldPassWord" :rules="[
            { required: true, validator: validatePass, trigger: 'change' },
          ]">
            <a-input-password v-model:value="formState.oldPassWord" />
          </a-form-item>
          <a-form-item :label="$t(`account.newPassword`)" name="newPassWord" :rules="[
            { required: true, validator: validateNewPass, trigger: 'change' },
          ]">
            <a-input-password v-model:value="formState.newPassWord" />
          </a-form-item>
          <a-form-item :label="$t(`account.affirmPassword`)" name="confirmPassWord" :rules="[
            {
              required: true,
              validator: validateOldNewPass,
              trigger: 'change',
            },
          ]">
            <a-input-password v-model:value="formState.confirmPassWord" />
          </a-form-item>
          <a-form-item :wrapper-col="{ offset: 7, span: 17 }">
            <a-button type="primary" html-type="submit" :loading="store.upLoading">{{ $t(`account.confirmChange`)
              }}</a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { loginStore } from '../../../../../store/login'
import type { FormInstance } from 'ant-design-vue'
import { ref, reactive, onBeforeMount } from 'vue'
import { message } from 'ant-design-vue'
import inter from '../../../../../utils/shared'
import md5 from 'js-md5'
import { useI18n } from 'vue-i18n'
const { locale, t } = useI18n()


interface FormState {
  oldPassWord: string
  newPassWord: string
  confirmPassWord: string
}
const formRef = ref<any>()
const formState = reactive<FormState>({
  oldPassWord: '',
  newPassWord: '',
  confirmPassWord: '',
})
const labelCol = { style: { width: '100px' } }
const store = loginStore()

let validatePass = async (_rule: any, value: string) => {
  let reg =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]])[A-Za-z\d`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]{8,}$/

  if (value === '') {
    return Promise.reject(`${t('login.userInput')}`)
  } else if (!reg.test(value)) {
    return Promise.reject(`${t('login.passwordHint2')}`)
  } else {
    return Promise.resolve()
  }
}
let validateNewPass = async (_rule: any, value: string) => {
  let reg =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]])[A-Za-z\d`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]{8,}$/

  if (value === '') {
    return Promise.reject(`${t('login.userInput')}`)
  } else if (!reg.test(value)) {
    return Promise.reject(`${t('login.passwordHint2')}`)
  } else {
    return Promise.resolve()
  }
}
let validateOldNewPass = async (_rule: any, value: string) => {
  let reg =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]])[A-Za-z\d`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]{8,}$/

  if (value === '') {
    return Promise.reject(`${t('login.userInput')}`)
  } else if (!reg.test(value)) {
    return Promise.reject(`${t('login.passwordHint2')}`)
  } else if (value !== formState.newPassWord) {
    return Promise.reject(`${t('login.passwordHint5')}`)
  } else {
    return Promise.resolve()
  }
}

const onFinish = () => {
  if (formState.newPassWord !== formState.confirmPassWord) {
    inter.errorReminder('warning', `${t('account.hint')}`, `${t('login.passwordHint5')}`)
    return
  }
  let params = {
    payload: {
      originalPassword: md5(formState.oldPassWord),
      password: md5(formState.newPassWord),
    },
    callback: () => {
      message.success(`${t('account.success')}`, 2)
      formRef.value.resetFields()
    },
  }
  store.getUpdatePassword(params)
}
</script>

<style lang="less">
@import url('./index.less');
</style>
